var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7779)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7779",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7779)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 8,
    height: 20,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H8V0H0V20Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1117 9.22157C15.8785 9.45477 15.4845 9.24389 15.5492 8.92049L15.9999 6.66671L14.6666 7.33337L13.9999 5.33337L13.3333 7.33337L11.9999 6.66671L12.4507 8.92049C12.5154 9.24389 12.1213 9.45477 11.8881 9.22157L11.569 8.90241C11.4388 8.77223 11.2277 8.77223 11.0975 8.90241L10.6666 9.33337L9.33325 8.66671L9.99992 10L9.56895 10.431C9.43878 10.5612 9.43878 10.7722 9.56895 10.9024L11.3333 12.6667H13.3333L13.6666 14.6667H14.3333L14.6666 12.6667H16.6666L18.4309 10.9024C18.5611 10.7722 18.5611 10.5612 18.4309 10.431L17.9999 10L18.6666 8.66671L17.3333 9.33337L16.9023 8.90241C16.7721 8.77223 16.5611 8.77223 16.4309 8.90241L16.1117 9.22157Z",
    fill: "#FF3131"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7779"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryCa);
export default __webpack_public_path__ + "static/media/Country=CA.179a45b9325f47717c4d7ec7e3eb6c70.svg";
export { ForwardRef as ReactComponent };